// Wire contract between the web app and shipped Electron shells: never rename a member or change a value.
export enum ElectronIpcChannel {
  ClosePopover = 'close-popover',
  SendTaskData = 'send-task-data',
  GetTaskCreationData = 'get-task-creation-data',
  PopoverHeight = 'popover-height',
  SetCreateTaskPopoverShortcut = 'setCreateTaskPopoverShortcut',
  GetCreateTaskPopoverShortcut = 'getCreateTaskPopoverShortcut',
  CreateTask = 'createTask',
  GetPushToken = 'getPushToken',
  GetTaskCreationDataRequest = 'getTaskCreationDataRequest',
  GetTaskCreationDataResponse = 'getTaskCreationDataResponse',
  SetAppVersion = 'setAppVersion',
  RequestNotificationPermission = 'request-notification-permission',
  OpenInBrowser = 'open-in-browser',
}
